import { apiGetAuth } from '@/utils/api'
import { API_PAYMENT_COMPANY } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  payment_company_list: {
    isLoading: false,
    data: {}
  },
  detail_payment_company: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_PAYMENT_COMPANY_LIST": (state, payload) => {
    state.payment_company_list = payload
  },
  "SET_DETAIL_PAYMENT_COMPANY": (state, payload) => {
    state.detail_payment_company = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getPaymentCompanyList(context, payload) {
    context.commit('SET_PAYMENT_COMPANY_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_PAYMENT_COMPANY.LIST, payload)
      context.commit('SET_PAYMENT_COMPANY_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_PAYMENT_COMPANY_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getDetailPaymentCompany(context, payload) {
    context.commit('SET_DETAIL_PAYMENT_COMPANY', { isLoading: true, data: {} })
    try {
      const response = await apiGetAuth(API_PAYMENT_COMPANY.BY_ID(payload))
      context.commit('SET_DETAIL_PAYMENT_COMPANY', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_PAYMENT_COMPANY', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_payment_company_list: state => {
    return state.payment_company_list
  },
  get_detail_payment_company: state => {
    return state.detail_payment_company
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
